import React from "react";
import { useHistory } from "react-router-dom";
import { eventCardStyles } from "../styles/homepageStyles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
// import DateRangeSharpIcon from '@material-ui/icons/DateRangeSharp';
// import ScheduleSharpIcon from '@material-ui/icons/ScheduleSharp';
import AttachMoneySharpIcon from "@material-ui/icons/AttachMoneySharp";
import services from "../services/services";
import toast from "react-hot-toast";
import Hidden from "@material-ui/core/Hidden";
import { checkEventStatus } from "./eventTabs/funcCalls";

import { newDateFormat } from "./../utils/helperFunctions/dateConversions";

// import format from 'date-fns/format';
// import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

const useStyles = makeStyles((theme) => eventCardStyles(theme));

export default function EventCard({ data, image, userType, dataFrom, userId }) {
  const classes = useStyles();
  const history = useHistory();
  const controlled = dataFrom !== "UpcomingEvents";
  // const timeZOne = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const { eventDateR, eventTimeR } = newDateFormat(
    data?.eventDate,
    data?.eventTime
  );

  const onClickWatchEvent = async (eventId, eventUniqueNo) => {
    const toastId = showLoadToaster("Please wait");
    const res = await checkEventStatus(userId, eventId, eventUniqueNo);
    if (res.eventStatus === true) {
      toast.dismiss();
      goToStream(res.streamDetails);
      return;
    } else {
      showErrToaster(res.eventStatus, toastId);
      return;
    }
  };

  const goToStream = (streamDetails) => {
    history.push("/together", { streamDetails: streamDetails });
  };

  const dataFromHostedEvents = () => {
    if (data.eventStatus === "cancelled") {
      return (
        <Typography className={classes.cancelledText}>Cancelled</Typography>
      );
    } else {
      return (
        <div className={classes.actions}>
          <Button
            size="medium"
            color="primary"
            className={classes.button}
            onClick={() => history.push("/reservebox", { data: data })}
          >
            Reserve Box
          </Button>

          <Button
            size="medium"
            color="primary"
            className={classes.button}
            onClick={() =>
              history.push("/addparticipants", {
                data: data,
                dataFrom: dataFrom,
              })
            }
          >
            Add Participants
          </Button>
          <Button
            size="medium"
            color="primary"
            // style={{ textTransform: 'capitalize' }}
            className={classes.button}
            onClick={() =>
              history.push("/viewevent", {
                eventId: data.eventId,
                eventUniqueNo: data.eventUniqueNo,
                userId: data.userId_id,
                dataFrom: dataFrom,
              })
            }
          >
            More..
          </Button>
        </div>
      );
    }
  };

  const showLoadToaster = (msg) => {
    toast.dismiss();
    const toastId = toast.loading(msg);
    return toastId;
  };

  const showErrToaster = (msg, toastId) => {
    toast.error(msg, { id: toastId });
  };

  const dataFromMyEventsOrHome = () => {
    return (
      <div className={classes.actions}>
        {data.assignBoxes?.length ? (
          <Button
            size="medium"
            color="primary"
            className={classes.button}
            onClick={() => history.push("/addparticipants", { data: data })}
          >
            Add Participants
          </Button>
        ) : null}

        {data.assignSeats?.length ? (
          <Button
            size="medium"
            color="primary"
            onClick={() => onClickWatchEvent(data.eventId, data.eventUniqueNo)}
            className={classes.button}
          >
            {data.eventStatus === "active"
              ? "Watch Event"
              : "Event not started"}
          </Button>
        ) : null}

        <Button
          size="medium"
          color="primary"
          // style={{ textTransform: 'capitalize' }}
          className={classes.button}
          onClick={() =>
            history.push(`/event/load/${data.eventId}/${data.eventUniqueNo}`, {
              eventId: data.eventId,
              eventUniqueNo: data.eventUniqueNo,
              userId: data.userId_id,
              dataFrom: dataFrom,
            })
          }
        >
          More..
        </Button>
      </div>
    );
  };

  const dataFromUpcomingEvents = () => {
    return (
      <div className={classes.actions}>
        {data.allowUsersToReserveBox === "Y" ? (
          <Button
            size="medium"
            color="primary"
            className={classes.button}
            onClick={() => {
              if (userId) {
                history.push("/reservebox", { data: data, dataFrom: dataFrom });
                return;
              } else {
                toast.dismiss();
                history.push("/login");
                toast.error("Please login/register", { duration: 4000 });
              }
            }}
          >
            Reserve Box
          </Button>
        ) : null}

        <Button
          size="medium"
          color="primary"
          className={classes.button}
          onClick={() => {
            if (userId) {
              history.push("/addparticipants", {
                data: data,
                dataFrom: dataFrom,
              });
              return;
            } else {
              toast.dismiss();
              history.push("/login");
              toast.error("Please login/register", { duration: 2500 });
            }
          }}
        >
          Select Seat
        </Button>

        <Button
          size="medium"
          color="primary"
          // style={{ textTransform: 'capitalize' }}
          className={classes.button}
          onClick={() =>
            history.push(`/event/share/${data.eventId}/${data.eventUniqueNo}`, {
              eventId: data.eventId,
              eventUniqueNo: data.eventUniqueNo,
              userId: data.userId_id,
              dataFrom: dataFrom,
            })
          }
        >
          More..
        </Button>
      </div>
    );
  };

  const dataFromLoggedInAPIcall = () => {
    const renderData =
      dataFrom === "HostedEvents"
        ? dataFromHostedEvents()
        : dataFromMyEventsOrHome();
    return renderData;
  };

  return (
    <Grid className={classes.gridOccupy}>
      <Paper elevation={0} className={classes.root}>
        <div className={classes.actionArea}>
          <Hidden xsDown>
            <CardMedia
              component="img"
              alt="icon"
              image={
                data?.eventId
                  ? data?.eventLogoUrl
                    ? services.event_logo_URL() + data.eventLogoUrl
                    : image
                  : ""
              }
              title="icon"
              className={classes.image}
            />
          </Hidden>

          <CardContent className={classes.content}>
            <Typography
              gutterBottom
              variant="h5"
              component="h3"
              className={classes.cardTitle}
            >
              {data?.eventName}
            </Typography>
            <div className={classes.descriptionContainer}>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                className={classes.cardDescription}
                style={
                  {
                    //   overflowWrap: 'anywhere',
                    //   overflow: 'hidden',
                    // maxHeight: 40,
                    //   textOverflow: 'clip',
                    //   msTextOverflow: 'clip',
                  }
                }
              >
                {data?.eventDescription}
              </Typography>
            </div>

            {controlled && dataFromLoggedInAPIcall()}
            {controlled || dataFromUpcomingEvents()}
          </CardContent>

          <CardContent className={classes.contentRight}>
            <div className={classes.detailsCont}>
              <div className={classes.priceCont}>
                <AttachMoneySharpIcon
                  style={{ fontSize: 20, fontWeight: 700 }}
                  // style={{  }}
                />
                <Typography
                  variant="body2"
                  style={{ marginLeft: "0px", fontSize: 17, fontWeight: 700 }}
                >
                  {data?.seatPrice}
                </Typography>
              </div>

              <div className={classes.dateCont}>
                {/* <DateRangeSharpIcon style={{ fontSize: 17 }} /> */}
                <Typography
                  variant="body2"
                  style={{
                    marginLeft: "5px",
                    marginTop: "5px",
                    fontSize: 12,
                    fontWeight: 450,
                    color: "#545454",
                  }}
                >
                  {eventDateR}
                </Typography>
              </div>
              <span className={classes.dummy} />
              <div className={classes.dateCont}>
                {/* <ScheduleSharpIcon style={{ fontSize: 17 }} /> */}
                <Typography
                  variant="body2"
                  style={{
                    marginLeft: "5px",
                    marginTop: "5px",
                    fontSize: 12,
                    fontWeight: 450,
                    color: "#545454",
                  }}
                >
                  {eventTimeR}
                </Typography>
              </div>
              <span className={classes.dummy} />
            </div>
          </CardContent>
        </div>
      </Paper>
    </Grid>
  );
}
